/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_pricing_subscription_current = /** @type {(inputs: { planName: NonNullable<unknown>, status: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`현재 구독: ${i?.planName} (${i?.status})`)
};

const en_pricing_subscription_current = /** @type {(inputs: { planName: NonNullable<unknown>, status: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Current Subscription: ${i?.planName} (${i?.status})`)
};

const ja_pricing_subscription_current = /** @type {(inputs: { planName: NonNullable<unknown>, status: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`現在のサブスクリプション: ${i?.planName} (${i?.status})`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ planName: NonNullable<unknown>, status: NonNullable<unknown> }} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pricing_subscription_current = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pricing_subscription_current(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("pricing_subscription_current", locale)
	if (locale === "ko") return ko_pricing_subscription_current(inputs)
	if (locale === "en") return en_pricing_subscription_current(inputs)
	return ja_pricing_subscription_current(inputs)
};